import * as actions from '../actions/advertisingOptionsActions';
import getOptions from '../selectors/getOptions';
import { observer } from 'mobx-react';
import { Toggle } from 'office-ui-fabric-react/lib';
import { Link } from 'office-ui-fabric-react/lib/Link';
import OptionDescription from 'owa-options-controls/lib/components/OptionDescription';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
const styles = require('./AdvertisingOptionFull.scss');

@observer
export default class AdvertisingOptionGdprChoiceView extends React.Component<{}, {}> {
    private switchToGdprPartnerListView = (evt: React.MouseEvent<EventTarget> | KeyboardEvent) => {
        actions.retrieveVendorList();
        actions.switchView(true);
    };

    render() {
        const {
            allowAccess,
            allowAdSelection,
            allowContentSelection,
            allowPersonalization,
            allowMeasurement,
        } = getOptions();

        return (
            <div className={styles.container}>
                <section>
                    <header className={styles.title}>
                        {strings.option_ads_heading_learn_more}
                    </header>
                    <OptionDescription>
                        {strings.option_ads_description_learn_more}
                    </OptionDescription>
                    <Link onClick={this.switchToGdprPartnerListView}>
                        {strings.option_ads_link_view_complete_list}
                    </Link>
                </section>

                <section>
                    <header className={styles.title}>
                        <div>{strings.option_ads_heading_allow_access}</div>
                        <Toggle checked={allowAccess} onChanged={actions.toggleAllowAccess} />
                    </header>
                    <OptionDescription>
                        {strings.option_ads_description_allow_access}
                    </OptionDescription>
                </section>

                <section>
                    <header className={styles.title}>
                        <div>{strings.option_ads_heading_allow_personalization}</div>
                        <Toggle
                            checked={allowPersonalization}
                            onChanged={actions.toggleAllowPersonalization}
                        />
                    </header>
                    <OptionDescription>
                        {strings.option_ads_description_allow_personalization}
                    </OptionDescription>
                </section>

                <section>
                    <header className={styles.title}>
                        <div>{strings.option_ads_heading_allow_ad_selection}</div>
                        <Toggle
                            checked={allowAdSelection}
                            onChanged={actions.toggleAllowAdSelection}
                        />
                    </header>
                    <OptionDescription>
                        {strings.option_ads_description_allow_ad_selection}
                    </OptionDescription>
                </section>

                <section>
                    <header className={styles.title}>
                        <div>{strings.option_ads_heading_allow_content_selection}</div>
                        <Toggle
                            checked={allowContentSelection}
                            onChanged={actions.toggleAllowContentSelection}
                        />
                    </header>
                    <OptionDescription>
                        {strings.option_ads_description_allow_content_selection}
                    </OptionDescription>
                </section>

                <section>
                    <header className={styles.title}>
                        <div>{strings.option_ads_heading_allow_analytics}</div>
                        <Toggle
                            checked={allowMeasurement}
                            onChanged={actions.toggleAllowMeasurement}
                        />
                    </header>
                    <OptionDescription>
                        {strings.option_ads_description_allow_analytics}
                    </OptionDescription>
                </section>
            </div>
        );
    }
}
